import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import Autocomplete from "@mui/material/Autocomplete";
import { classNames, htmlValidation } from "../../helpers/utils";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useStore } from "../../helpers/helpers";
import { useTranslation } from "react-i18next";
import { FormButtons } from "../../components/cm-components";
import { RNCheckBoxTree } from "../../components";
import { safe_get } from "../../report-visuals/report-utils";
import Select from "react-select";
import { useParams } from "react-router-dom";
import _ from "lodash";

const filterTypes = ["Surveys", "User", "Level1", "Status"];

const StatusList = [
  {
    label: "Not Started",
    value: "not-started",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "In Progress",
    value: "in-progress",
  },
];

export const TaskFilters = observer((props) => {
  const rootStore = useStore();
  const { taskManagerStore, projectStore } = rootStore;
  const { users } = taskManagerStore;
  const { task_filters } = taskManagerStore;
  const [activeFilter, setActiveFilter] = useState(filterTypes[0]);
  const { projectid } = useParams();

  const [surveys, setSurveys] = useState([]);
  const [selectedSurveys, setSelectedSurveys] = useState(
    safe_get(task_filters, "surveys", [])
  );

  const [selectedLevel1, setselectedLevel1] = useState(
    safe_get(task_filters, "pivLevel1", [])
  );
  const [selectedStatus, setSelectedStatus] = useState(
    safe_get(task_filters, "status", [])
  );

  useEffect(() => {
    const active_project = JSON.parse(localStorage.getItem("__active_project"));
    setSurveys(safe_get(active_project, "surveys", []));
  }, [projectid]);

  const retriveUsers = () => {
    const users_by_id = [];
    const ex = safe_get(task_filters, "userList", []);

    if (ex.length < 0) return [];

    ex.forEach((item, index) => {
      const t = users.find((x) => x.id === item);
      console.log(t);
      users_by_id.push(t);
    });

    return users_by_id;
  };

  const [selectedUsers, setSelectedUsers] = useState(retriveUsers());

  const hierarchy = projectStore.getProjectProperty("hierarchy", {});

  const toggleOption = (option) => {
    setSelectedStatus((prevSelected) => {
      if (prevSelected.includes(option)) {
        return prevSelected.filter((id) => id !== option);
      } else {
        return [...prevSelected, option];
      }
    });
  };

  const apply_filters = () => {
    taskManagerStore.update_task_filters({
      userList: selectedUsers.map((x) => x["id"]),
      pivLevel1: selectedLevel1,
      status: selectedStatus,
      surveys: selectedSurveys,
    });
    taskManagerStore.update_task_filter_modal(false);
  };

  const checkForStatus = (val: string) => {
    return selectedStatus?.length > 0 ? selectedStatus.includes(val) : false;
  };

  const [t] = useTranslation("task_manager");
  return (
    <>
      <div className="w-full h-full flex flex-col md:flex-row">
        {/* Filter Tabs */}
        <div className="w-full md:w-1/4 h-auto md:h-full border-r border-gray-200 bg-gray-50">
          {filterTypes.map((tab) => (
            <button
              key={tab}
              className={classNames(
                activeFilter == tab
                  ? "text-blue-600 bg-white border-l-4 border-blue-600 font-semibold"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100",
                "w-full text-left text-base py-3 px-4 transition-colors duration-200"
              )}
              onClick={() => {
                setActiveFilter(tab);
              }}
            >
              {tab}
            </button>
          ))}
        </div>
        {/* Filter Content */}
        <div className="flex-1 p-4 md:p-6 bg-white overflow-y-auto">
          {activeFilter === "Surveys" && (
            <div>
              <p className={"text-lg font-semibold text-gray-800 mb-4"}>
                {t("selecting_survey")}
              </p>
              <Select
                name={"Select Survey"}
                defaultValue={selectedSurveys}
                options={surveys.map((survey) => {
                  return {
                    label: survey.name,
                    value: survey.id,
                  };
                })}
                onChange={(val, action) => {
                  const ids = val.map((v) => v.value);
                  setSelectedSurveys(val);
                }}
                placeholder={"Survey"}
                className="w-full h-auto rounded z-999 focus:shadow outline-none basic-multi-select "
                classNamePrefix="select"
                isMulti
                required={true}
              />
            </div>
          )}

          {activeFilter === "User" && (
            <div>
              <p className={"text-lg font-semibold text-gray-800 mb-4"}>
                {t("customize_data_display")}
              </p>
              <Autocomplete
                id="select-user"
                multiple
                value={selectedUsers}
                filterSelectedOptions
                limitTags={2}
                getOptionLabel={(option) => option["name"]}
                isOptionEqualToValue={(option, value) =>
                  option.name === value.name
                }
                options={users.map((user) => {
                  return {
                    name: `${user["name"]}`,
                    phone: `${user["phonenum"]}`,
                    id: user["id"],
                    profileimageuri: user["profileimageuri"],
                  };
                })}
                onChange={(event, v) => {
                  setSelectedUsers([...v]);
                }}
                renderOption={(props, option, { selected }) => {
                  return (
                    <Box
                      key={option["id"]}
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      <img
                        loading="lazy"
                        width="40"
                        src={option["profileimageuri"]}
                      />
                      <div>
                        <p>{option["name"]}</p>
                        <p>{option["phonenum"]}</p>
                      </div>
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select User"
                    onChange={(event) => {
                      htmlValidation(event);
                      console.log("event", event.target.value);
                    }}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "users",
                    }}
                  />
                )}
              />
            </div>
          )}
          {activeFilter === "Level1" && (
            <div>
              <p className={"text-lg font-semibold text-gray-800 mb-4"}>
                {t("selecting_level1")}
              </p>
              <RNCheckBoxTree
                data={hierarchy}
                on_node_selection={(nodes) => {
                  setselectedLevel1(nodes);
                }}
                checked_nodes={selectedLevel1}
              />
            </div>
          )}

          {activeFilter === "Status" && (
            <div>
              <p className={"text-lg font-semibold text-gray-800 mb-4"}>
                {t("selecting_task_status")}
              </p>
              <div className="space-y-3">
                {StatusList.map((status, index) => {
                  return (
                    <label
                      key={index}
                      className="flex items-center p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors"
                      htmlFor={`custom-checkbox-${status.value}`}
                    >
                      <input
                        type="checkbox"
                        id={`custom-checkbox-${status.value}`}
                        className="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                        value={status.value}
                        onChange={() => {
                          toggleOption(status.value);
                        }}
                        checked={checkForStatus(status.value)}
                      />
                      <span className="ml-3 text-gray-700 font-medium">
                        {status.label}
                      </span>
                    </label>
                  );
                })}
              </div>
            </div>
          )}

          <FormButtons
            onSave={apply_filters}
            onCancel={() => taskManagerStore.update_task_filter_modal(false)}
            type={"button"}
          />
        </div>
      </div>
    </>
  );
});
